// export const tokenService = {
//   getAccessToken: () => localStorage.getItem("accessToken"),

//   getRefreshToken: () => localStorage.getItem("refreshToken"),

//  setTokens: (data: { accessToken: string; refreshToken: string }) => {
//   if (data.accessToken) localStorage.setItem("accessToken", data.accessToken);
//   if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
// },

//   clearTokens: () => {
//     localStorage.removeItem("accessToken");
//     localStorage.removeItem("refreshToken");
//     localStorage.removeItem("partner");
//   },
// };


export const tokenService = {
  getAccessToken: () => localStorage.getItem("accessToken"),
  getRefreshToken: () => localStorage.getItem("refreshToken"),

  setTokens: (data: { accessToken: string; refreshToken: string }) => {
    if (data.accessToken) localStorage.setItem("accessToken", data.accessToken);
    if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
  },

  /**
   * The "Master Wipe" - Single source of truth for clearing browser data
   */
  clearAllData: () => {
    // 1. Nuke Storage
    localStorage.clear();
    sessionStorage.clear();

    // 2. Nuke Cookies
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  },
};